export default __webpack_public_path__ + "static/media/002.4ce5f00d.jpg";